import Layout from '@/layout'
// import routerView from '@/layout/routerView.vue'
const openPlatformRouter = {
  path: '/openPlatform',
  component: Layout,
  redirect: '/openPlatform/apiInterface',
  name: 'openPlatform',
  permissionCode: '97773',
  meta: {
    title: '开放平台',
    icon: 'openPlat'
  },
  children: [
    // {
    //   path: 'applaction',
    //   component: () => import('@/views/openPlatform/page/applaction.vue'),
    //   name: 'applaction',
    //   permissionCode: '21768',
    //   meta: { title: '应用接入' }
    // },
    {
      path: 'apiInterface',
      component: () => import('@/views/openPlatform/page/apiInterface.vue'),
      name: 'apiInterface',
      permissionCode: '45002',
      meta: { title: 'API接口文档', hidePadding: true }
    }
  ]
}
export default openPlatformRouter
